import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { Map } from './map-component';

/* ---------------- Page ------------------ */
export const MapPage = () => {
  const [userCoords, setUserCoords] = useState({ lat: 38.02, lng: 23.805 });
  const [isRechargeGreece, setIsRechargeGreece] = useState(false);

  useEffect(() => {
    if ('geolocation' in navigator) {
      console.log('Available');
      navigator.geolocation.getCurrentPosition(function (position) {
        console.log('Latitude is :', position.coords.latitude);
        console.log('Longitude is :', position.coords.longitude);
        setUserCoords({ lat: position.coords.latitude, lng: position.coords.longitude });
      });
    } else {
      console.log('Not Available');
    }
    // RechargeGreece=1
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const rechargeGreece = urlParams.get('recharge-greece');
    setIsRechargeGreece(rechargeGreece === '1');
  }, []);
  return (
    <Card className="shadow">
      {/* <Card.Header>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
          <Card.Title className="m-0" style={{ justifyContent: 'center' }}>
            Κάδοι Ανακύκλωσης Μπαταριών - Αφής
          </Card.Title>
        </div>
      </Card.Header> */}
      <Card.Body id="map-conatainer" className="nopadding" style={{ minHeight: '350px' }}>
        {/* <div className="m-5">Τοποθεσία Χρήστη = {JSON.stringify(userCoords)}</div> */}
        <Map center={userCoords} isRechargeGreece={isRechargeGreece} />
      </Card.Body>
    </Card>
  );
};
